module.exports = __webpack_public_path__ + "img/5.8249cc11.png";